import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ChatView from '../features/ChatView/components/ChatView';

// keep this in case we ever want to show a full page (maintenance or loading screen or something idk)
export const AppRouter: React.FC = () => {
    return (
        <Routes>
            <Route path="/*" element={<ChatView />} />
        </Routes>
    );
};

export default AppRouter;
